export const FavoriteFilled: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
			<path
				d="M6.57031 4.17578C6.84297 4.72989 7.35502 5.12448 7.95508 5.25L8.07617 5.27148L9.35645 5.45898L8.42578 6.37012C8.01509 6.77191 7.79941 7.32728 7.82617 7.89355L7.85254 8.13574L8.07227 9.41895L6.93359 8.81836C6.38615 8.52949 5.7378 8.51103 5.17773 8.76367L5.06641 8.81836L3.92773 9.41895L4.14746 8.13574C4.24408 7.56955 4.09214 6.99349 3.73828 6.55078L3.57422 6.37012L2.64355 5.45898L3.92383 5.27148C4.53501 5.18235 5.06819 4.81668 5.37207 4.28418L5.42969 4.17578L6 3.0166L6.57031 4.17578Z"
				fill="url(#paint0_linear_225_26928)"
				stroke="url(#paint1_linear_225_26928)"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_225_26928"
					x1="11.5"
					y1="0.75"
					x2="0.5"
					y2="0.75"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F7C500" />
					<stop offset="1" stopColor="#F7B500" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_225_26928"
					x1="11.5"
					y1="0.75"
					x2="0.5"
					y2="0.75"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F7C500" />
					<stop offset="1" stopColor="#F7B500" />
				</linearGradient>
			</defs>
		</svg>
	);
};
